<template>
  <div id="Header">
      <b-navbar toggleable="lg" type="dark" variant="info" class="hdr">
          <b-navbar-brand href="/" class="exper1"><span class="sr-only">Home page</span><span class="exper2"><font-awesome-icon icon="home" size="lg" /></span></b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav>
                <b-nav-item @click="showItemsList()" class="exper">{{$t('NEWS')}}</b-nav-item>
                <b-nav-item @click="showTravels()" class="exper">{{$t('TRAVELS')}}</b-nav-item>
                <b-nav-item @click="showOffers()" class="exper">{{$t('OFFERS')}}</b-nav-item>
                <!-- <b-nav-item @click="showAuthorsList()" class="exper">{{$t('AUTHORS')}}</b-nav-item> -->
                <b-nav-form>
                    <b-input-group size=sm class="sm-2" style="min-width:10em;max-width:15em">
                        <b-form-input v-model="searchTxt" @keydown.native.enter.prevent="search()" style="font-size:1em">
                            <span class="sr-only">Search</span>
                        </b-form-input>
                        <b-input-group-append class="exper1">
                            <b-button variant="outline" @click="search()" aria-label="Search"><span class="exper2"><font-awesome-icon icon="search" size="lg"  /></span> </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-nav-form>
                <b-nav-item class="exper1" @click="shareItem=true"><span class="sr-only">Share</span><font-awesome-icon icon="share-alt" size="lg" /></b-nav-item>

            </b-navbar-nav>
            <b-navbar-nav class="ml-auto">
                <b-nav-item class="exper1" @click="$showDoc('Help')"><span class="sr-only">Help</span><font-awesome-icon icon="question" size="lg" /></b-nav-item>
                <b-nav-item class="exper" @click="toOffl()" v-show="app"><b>{{$t('TO_OFFL')}}</b></b-nav-item>
                <b-nav-item class="exper" @click="Login()"><b>{{$t('SIGN_IN')}}</b></b-nav-item>

                <b-nav-item-dropdown right class="exper1" v-b-popover.hover.top="this.$t('INT_LOC')">
                    <template v-slot:button-content>
                        <img src="./imgs/ru.png" v-if="$i18n.locale=='ru'" alt="ru">
                        <img src="./imgs/en.png" v-if="$i18n.locale=='en'" alt="en">
                    </template>
                    <b-dropdown-item href="#" @click="$chIntLoc('ru')"><b-button><img src="./imgs/ru.png" alt="ru"></b-button> ru</b-dropdown-item>
                    <b-dropdown-item href="#" @click="$chIntLoc('en')"><b-button><img src="./imgs/en.png" alt="en"></b-button> en</b-dropdown-item>
                </b-nav-item-dropdown>
            </b-navbar-nav>
        </b-collapse>
      </b-navbar>

      <ShareItem
              v-on:closeShare="shareItem=false"
              v-if="shareItem"
      />

  </div>
</template>

<script>
import { BNavbar, BCollapse, BNavbarBrand, BNavbarToggle, BNavbarNav, BNavItem, BDropdownItem,
    BNavItemDropdown, BNavForm, BFormInput, BInputGroup, BInputGroupAppend, BButton } from 'bootstrap-vue';
import ShareItem from "./ShareItem.vue";

export default {
  name: 'Header',
  components: {
    ShareItem,
    BNavbar, BCollapse, BNavbarBrand, BNavbarToggle,  BNavbarNav,  BNavItem, BDropdownItem,
    BNavItemDropdown, BNavForm, BFormInput, BInputGroup, BInputGroupAppend, BButton
  },
  data: function() {
    return {
        //intLoc: this.$i18n.locale,
        searchTxt: '',
        app: false,
        shareItem: false
    }
  },
  created() {
    this.$nextTick(function () {
        this.app = this.$store.state.app;
    });
  },
  methods: {
    Login() {
        this.$router.push({ path: '/Login' }).catch(() => {}); },
    showItemsList() {
        /* eslint-disable */
        this.$router.push({ path: '/ItemList' }).catch(err => {})
        /* eslint-enable */
    },
    showAuthorsList() {
        this.$router.push({ path: '/AuthorsList' }).catch(() => {})
    },
    showTravels() { this.$router.push({  path: '/TravelGeo' }).catch( () => {} ) },
    showOffers() { this.$router.push({  path: '/OffersGeo' }).catch( () => {} ) },
    search() {
        if(!this.searchTxt) this.$bvModal.msgBoxOk(this.$t('EMPTY'));
        else {
            this.$router.push({
                path: '/Search',
                query: {
                    searchTxt: this.$addEncHyp(this.searchTxt)
                }
            }).catch(() => {})
        }
    },
    toOffl() {
        this.$store.commit('setApp', false);
        this.app = false;
        if(typeof AndroidInterface!='undefined') window.location = 'dist/index.html';
    }
  },
  watch: {
    '$store.state.app': function() {
        this.app = this.$store.state.app;
    }
  }
}

</script>

<style>
</style>
